/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// Copyright (c) 2021 Deere & Company

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default class Calendar extends Component {

    weekdayshort = moment.weekdaysShort();

    state = {
        showCalendarTable: true,
        showMonthTable: false,
        dateObject: moment(),
        allmonths: moment.months(),
        showYearNav: false,
        data: []
    };

    componentDidMount () {

        const dateObject = moment().set( 'year', this.props.year ).set( 'month', this.props.month ).set( 'date', 1 );
        this.setState( {
            dateObject,
            data: [...this.props.data].map( i => ( i ? { ...i } : i ) )
        } );

    }

    static getDerivedStateFromProps ( props, state ) {

        let updatedState = {};

        if ( !state.data.length && props.data.length ) {

            updatedState = {
                ...updatedState,
                data: [...props.data].map( i => ( i ? { ...i } : i ) )
            };

        }

        if ( state.dateObject.month !== props.month || state.dateObject.year !== props.year ) {

            const dateObject = moment().set( 'year', props.year ).set( 'month', props.month ).set( 'date', 1 );
            updatedState = {
                ...updatedState,
                dateObject
            };

        }
        if ( updatedState !== {} ) return updatedState;

        return null;

    }

    year = () => this.state.dateObject.format( 'Y' );

    currentDay = () => this.state.dateObject.format( 'D' );

    firstDayOfMonth = ( ) => {

        const { dateObject } = this.state;
        const firstDay = moment( dateObject )
            .startOf( 'month' )
            .format( 'd' ); // Day of week 0...1..5...6
        return firstDay;

    };

    month = () => this.state.dateObject.format( 'MMMM' );

    showMonth = ( ) => {

        this.setState( {
            showMonthTable: !this.state.showMonthTable,
            showCalendarTable: !this.state.showCalendarTable
        } );

    };

    setMonth = month => {

        const monthNo = this.state.allmonths.indexOf( month );
        let dateObject = { ...this.state.dateObject };
        dateObject = moment( dateObject ).set( 'month', monthNo );
        this.setState( {
            dateObject,
            showMonthTable: !this.state.showMonthTable,
            showCalendarTable: !this.state.showCalendarTable
        } );

    };

    MonthList = props => {

        const months = [];
        props.data.forEach( data => {

            months.push(
                <td
                    key={data}
                    className="calendar-month"
                    onClick={() => {

                        this.setMonth( data );

                    }}
                >
                    <span>{data}</span>
                </td>
            );

        } );
        const rows = [];
        let cells = [];

        months.forEach( ( row, i ) => {

            if ( i % 3 !== 0 || i === 0 ) {

                cells.push( row );

            } else {

                rows.push( cells );
                cells = [];
                cells.push( row );

            }

        } );
        rows.push( cells );
        const monthlist = rows.map( ( d, idx ) => <tr key={`month-row-${idx}`}>{d}</tr> );

        return (
            <table className="calendar-month">
                <thead>
                    <tr>
                        <th colSpan="4">Select a Month</th>
                    </tr>
                </thead>
                <tbody>{monthlist}</tbody>
            </table>
        );

    };

    showYearEditor = () => {

        this.setState( {
            showYearNav: true,
            showCalendarTable: !this.state.showCalendarTable
        } );

    };

    prev = () => moment( this.state.dateObject ).subtract( 1, 'month' );

    next = () => moment( this.state.dateObject ).add( 1, 'month' );

    setYear = year => {

        // alert(year)
        let dateObject = { ...this.state.dateObject };
        dateObject = moment( dateObject ).set( 'year', year );
        this.setState( {
            dateObject,
            showMonthTable: !this.state.showMonthTable,
            showYearNav: !this.state.showYearNav
        } );

    };

    onYearChange = e => {

        this.setYear( e.target.value );

    };

    getDates = ( startDate, stopDate ) => {

        const dateArray = [];
        let currentDate = moment( startDate );
        const endDate = moment( stopDate );
        while ( currentDate <= endDate ) {

            dateArray.push( moment( currentDate ).format( 'YYYY' ) );
            currentDate = moment( currentDate ).add( 1, 'year' );

        }
        return dateArray;

    }

    daysInMonth = () => this.state.dateObject.daysInMonth();

    YearTable = props => {

        const months = [];
        const nextten = moment()
            .set( 'year', props )
            .add( 'year', 12 )
            .format( 'Y' );

        const tenyear = this.getDates( props, nextten );

        tenyear.forEach( data => {

            months.push(
                <td
                    key={data}
                    className="calendar-month"
                    onClick={() => {

                        this.setYear( data );

                    }}
                >
                    <span>{data}</span>
                </td>
            );

        } );
        const rows = [];
        let cells = [];

        months.forEach( ( row, i ) => {

            if ( i % 3 !== 0 || i === 0 ) {

                cells.push( row );

            } else {

                rows.push( cells );
                cells = [];
                cells.push( row );

            }

        } );
        rows.push( cells );
        const yearlist = rows.map( ( d, idx ) => <tr key={`year-row-${idx}`}>{d}</tr> );

        return (
            <table className="calendar-month">
                <thead>
                    <tr>
                        <th colSpan="4">Select a Yeah</th>
                    </tr>
                </thead>
                <tbody>{yearlist}</tbody>
            </table>
        );

    };

    showDetail = ( month, year ) => {

        this.props.showDetail( month, year );

    }

    flagChanged = ( d, flag ) => {

        const newData = [...this.state.data];
        if ( !newData[d] ) newData[d] = {};
        newData[d].nonProdDayFlag = flag;
        this.setState( {
            data: [...newData].map( i => ( i ? { ...i } : i ) )
        } );

    }

    submitDates = () => {

        this.props.onSubmit( this.state.data );

    }

    onMonthClick = mon => {

        this.props.onMonthClick( mon.format( 'M' ), mon.format( 'Y' ), this.state.data );

    }

    checkUpdated = ( d, data, org ) => {

        if ( !data[d] || ( !org[d] && data[d].nonProdDayFlag === 'P' ) ) return false;
        if ( !org[d] && data[d].nonProdDayFlag !== 'P' ) return true;
        if ( org[d].nonProdDayFlag !== data[d].nonProdDayFlag ) return true;
        return false;

    }

    renderDateCell = ( d, data ) => {

        if ( !this.props.detail ) {

            return (
                <td key={d} className={`calendar-day ${( data && data[d] && data[d].nonProdDayFlag === 'S' ) ? 'shutdown-day' : ''} ${( data && !data[d] ) ? 'production-day' : ''} ${( data && data[d] && data[d].nonProdDayFlag === 'H' ) ? 'holiday-day' : ''}`}>
                    <span>
                        {d}
                    </span>
                </td>
            );

        }
        const { type } = this.props;
        const changed = this.checkUpdated( d, data, this.props.data );
        return (
            <td key={d} className="calendar-day">
                <div className="date-header">{d}</div>
                <div className={`date-content ${changed ? 'date-changed' : ''}`}>
                    <div>
                        <input
                            type="radio"
                            id={`radio_P_${d}`}
                            name={`${d}`}
                            value="P"
                            checked={!data[d] || data[d].nonProdDayFlag === 'P'}
                            onChange={this.flagChanged.bind( this, d, 'P' )}
                        />
                        <label htmlFor="P">{type === 'factory' ? 'Production Day' : 'Shipping Day'}</label>
                    </div>
                    {type === 'factory' && (
                        <div>
                            <input
                                type="radio"
                                id={`radio_H_${d}`}
                                name={`${d}`}
                                value="H"
                                checked={data[d] && data[d].nonProdDayFlag === 'H'}
                                onChange={this.flagChanged.bind( this, d, 'H' )}
                            />
                            <label htmlFor="P">Shutdown - Holiday</label>
                        </div>
                    )}
                    <div>
                        <input
                            type="radio"
                            id={`radio_S_${d}`}
                            name={`${d}`}
                            value="S"
                            checked={data[d] && data[d].nonProdDayFlag === 'S'}
                            onChange={this.flagChanged.bind( this, d, 'S' )}
                        />
                        <label htmlFor="P">{type === 'factory' ? 'Shutdown - Factory' : 'No Shipping'}</label>
                    </div>
                </div>
            </td>
        );

    }

    render ( ) {

        const {
            detail, month, year
        } = this.props;
        const { data } = this.state;
        const weekdayshortname = this.weekdayshort.map( day => <td key={day} className="calendar-week-short-name">{day}</td> );
        const blanks = [];
        for ( let i = 0; i < this.firstDayOfMonth( ); i += 1 ) {

            blanks.push( <td className="calendar-day empty" /> );

        }
        const daysInMonth = [];
        const pMon = this.prev();
        const nMon = this.next();
        for ( let d = 1; d <= this.daysInMonth(); d += 1 ) {

            // const currentDay = d === this.currentDay() ? 'today' : '';
            daysInMonth.push(
                this.renderDateCell( d, data )
            );

        }
        const totalSlots = [...blanks, ...daysInMonth];
        const rows = [];
        let cells = [];

        totalSlots.forEach( ( row, i ) => {

            if ( i % 7 !== 0 ) {

                cells.push( row );

            } else {

                rows.push( cells );
                cells = [];
                cells.push( row );

            }
            if ( i === totalSlots.length - 1 ) {

                // let insertRow = cells.slice();
                rows.push( cells );

            }

        } );

        const daysinmonth = rows.map( ( d, idx ) => <tr key={`day-row-${idx}`}>{d}</tr> );

        return (
            <div className="calendar-month">
                {this.state.showCalendarTable && (
                    <div className="calendar-date">
                        <table className="calendar-day">
                            <thead>
                                <tr>
                                    {detail && <th><span className="month-link" onClick={this.onMonthClick.bind( this, pMon )}>{`${pMon.format( 'MMM' )}`}</span></th>}
                                    <th colSpan={detail ? 5 : 7}><span className={!detail ? 'month-header' : ''} onClick={!detail ? this.showDetail.bind( this, month, year ) : undefined}>{`${this.month()} ${this.year()}`}</span></th>
                                    {detail && <th><span className="month-link" onClick={this.onMonthClick.bind( this, nMon )}>{`${nMon.format( 'MMM' )}`}</span></th>}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>{weekdayshortname}</tr>
                                {daysinmonth}
                            </tbody>
                        </table>
                        {detail && (
                            <div>
                                <button className="" type="button" onClick={this.props.resetDates}>
                                    <span> Reset </span>
                                </button>
                                <button className="primary-button" type="button" onClick={this.submitDates.bind( this )}>
                                    <span> Submit </span>
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );

    }

}

Calendar.displayName = 'Calendar';
Calendar.propTypes = {
    month: PropTypes.number,
    year: PropTypes.number,
    detail: PropTypes.bool,
    data: PropTypes.array,
    showDetail: PropTypes.func,
    type: PropTypes.string,
    onSubmit: PropTypes.func,
    onMonthClick: PropTypes.func,
    resetDates: PropTypes.func
};
Calendar.defaultProps = {
    detail: false
};
